/**
 * SearchInput
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form, Input } from 'semantic-ui-react';
import debounce from 'lodash.debounce';

// Workspaces
import { makeSelectQueryStringValue } from '../../workspaces/react-router-selectors';

// Actions
import { updateQueryString } from '../../services/router/actions';

interface Props {
    placeholder?: string;
    search: string;
    updateQueryString: Function;
}

interface State {
    value: string;
}

export class SearchInput extends React.Component<Props, State> {
    static defaultProps = {
        search: '',
        placeholder: 'Search'
    };

    constructor(props: Props) {
        super(props);
        const { search } = props;

        this.state = {
            value: search
        };

        this.updateQueryString = debounce(this.updateQueryString, 300);
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.search !== this.props.search) {
            this.setState({ value: this.props.search });
        }
    }

    handleChange = (event: SyntheticInputEvent<EventTarget>) => {
        const { value } = event.target;

        this.setState({ value }, () => {
            this.updateQueryString();
        });
    };

    updateQueryString = () => {
        this.props.updateQueryString({
            page: undefined,
            search: this.state.value || undefined,
            selectedEvent: undefined
        });
    };

    render() {
        const { placeholder } = this.props;
        return (
            <Form
                autoComplete="off"
                onSubmit={event => {
                    event.preventDefault();
                    this.updateQueryString();
                }}
            >
                <Form.Field style={{ marginBottom: 0 }}>
                    <Input
                        id="search"
                        icon="search"
                        onChange={this.handleChange}
                        placeholder={placeholder}
                        type="search"
                        value={this.state.value}
                    />
                </Form.Field>
            </Form>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    search: makeSelectQueryStringValue('search')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(SearchInput);
